import styles from './SelectDropdown.module.scss';

// Redux
import { useAppDispatch } from '../src/app/hooks';

export default function SelectDropdown(
  name,
  id,
  options,
  validation,
  registration,
  errors,
  clearErrors,
  defaultOption,
  number,
  reduxFn,
  fn,
  type,
  isShowErrorMsg = true,
  isSupport = false
) {
  const dispatch = useAppDispatch();
  const errorMsgFormat = (errorMsg) => {
    if (errorMsg.split(' ').includes('Select')) {
      let formattedErr = errorMsg.replace('Select ', '');
      return formattedErr;
    }
    return errorMsg;
  };
  return (
    <>
      <select
        type="text"
        id="select-dropdown"
        {...validation}
        onChange={(e) => {
          validation && validation.onChange(e);
          clearErrors && clearErrors(registration);
          if (reduxFn) dispatch(reduxFn(e.target.value));
          if (fn) {
            if (type === 'index') {
              fn(e.target.selectedIndex);
            } else {
              fn(e.target.value);
            }
          }
        }}
        className={
          errors[registration] && errors[registration].type
            ? `${styles.selectDropdownDropDown} ${styles.inputError}`
            : isSupport
              ? styles.selectDropdownSupport
              : styles.selectDropdownDropDown
        }
        id={id}
      >
        <option value={defaultOption}>{number ? number : defaultOption}</option>
        {options &&
          options.map((option) => {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            );
          })}
      </select>
      {isShowErrorMsg && (
        <>
          {errors[registration] && errors[registration].type === 'required' && (
            <div className={styles.formError}>This field is required</div>
          )}
          {errors[registration] &&
            errors[registration].type === 'maxLength' && (
              <div className={styles.formError}>
                Please choose a valid state
              </div>
            )}
          {errors[registration] && errors[registration].type === 'validate' && (
            <div className={styles.formError}>{`Select a valid ${errorMsgFormat(
              defaultOption
            )}`}</div>
          )}
        </>
      )}
    </>
  );
}
